import React from 'react'
import { FormattedMessage } from 'react-intl'
import Switch from '@material-ui/core/Switch'
import { withStyles } from '@material-ui/core/styles'

const IOSSwitch = withStyles((theme) => ({
    root: {
        width: 32,
        height: 16,
        padding: 0,
        margin: '2px 0',
    },
    switchBase: {
        padding: 1,
        '&$checked': {
            transform: 'translateX(16px)',
            color: theme.palette.common.white,
            '& + $track': {
                backgroundColor: theme.palette.primary.main,
                opacity: 1,
                border: 'none',
            },
        },
        '&$focusVisible $thumb': {
            color: theme.palette.primary.main,
            border: 'none',
        },
    },
    thumb: {
        width: 14,
        height: 14,
    },
    track: {
        boxSizing: 'border-box',
        borderRadius: 16 / 2,
        border: 'none',
        backgroundColor: `#e1e1e1`,
        opacity: 1,
        transition: theme.transitions.create(['background-color']),
    },
    checked: {},
    focusVisible: {},
}))(({ classes, ...props }) => {
    return (
        <Switch
            focusVisibleClassName={classes.focusVisible}
            disableRipple
            classes={{
                root: classes.root,
                switchBase: classes.switchBase,
                thumb: classes.thumb,
                track: classes.track,
                checked: classes.checked,
            }}
            {...props}
        />
    )
})

function CameraSwitch({ onToggle, checked, cameraSwitchRef, className }) {
    return (
        <div className={className}>
            <div>
                <FormattedMessage id="camera_switch" />
            </div>
            <div ref={cameraSwitchRef} className="switch">
                <IOSSwitch onChange={onToggle} checked={checked} />
            </div>
        </div>
    )
}

export default CameraSwitch
